import React from 'react';
import { VideoFeeds } from '../VideoFeeds';
import { VideoControlButtons } from './VideoControlButtons';
import { FilterType } from '../VideoFilters';

interface PiPLayoutProps {
  // Video props
  videoSizeRatio: number;
  swapPositions?: boolean;
  triggerResetConnection: boolean;
  setTriggerResetConnection: React.Dispatch<React.SetStateAction<boolean>>;
  sessionActive: boolean;
  handleSessionActive: (sessionActive: boolean) => void;
  selfFilter: string;

  // Control buttons
  isPeerAudioMuted: boolean;
  isPeerVideoHidden: boolean;
  togglePeerAudioMute: () => void;
  togglePeerVideoHide: () => void;
  onFilterChange: (filter: FilterType, intensity: number, filterStyle: string) => void;
  onReport?: () => void;
  onSwapPositions?: () => void;
  rtcConnectionState?: string;
}

/**
 * Picture-in-Picture video layout with overlay controls
 */
export const PiPLayout: React.FC<PiPLayoutProps> = ({
  videoSizeRatio,
  swapPositions,
  triggerResetConnection,
  setTriggerResetConnection,
  sessionActive,
  handleSessionActive,
  selfFilter,
  isPeerAudioMuted,
  isPeerVideoHidden,
  togglePeerAudioMute,
  togglePeerVideoHide,
  onFilterChange,
  onReport,
  onSwapPositions,
  rtcConnectionState
}) => {
  return (
    <div className="flex-1 p-0 flex flex-col overflow-hidden">
      <div className="relative flex-1 flex flex-col overflow-hidden">
        <div className="flex-1 relative overflow-hidden bg-black max-h-full">
          {/* Overlay control buttons */}
          {(sessionActive || true) && (
            <VideoControlButtons
              isPeerAudioMuted={isPeerAudioMuted}
              isPeerVideoHidden={isPeerVideoHidden}
              togglePeerAudioMute={togglePeerAudioMute}
              togglePeerVideoHide={togglePeerVideoHide}
              onFilterChange={onFilterChange}
              onReport={onReport}
              onSwapPositions={onSwapPositions}
              showSwapButton={true}
              showReportButton={rtcConnectionState === 'connected'}
            />
          )}

          {/* Video feeds */}
          <VideoFeeds
            currentLayout="picture-in-picture"
            swapPositions={swapPositions}
            videoSizeRatio={videoSizeRatio}
            triggerResetConnection={triggerResetConnection}
            setTriggerResetConnection={setTriggerResetConnection}
            sessionActive={sessionActive}
            handleSessionActive={handleSessionActive}
            selfFilter={selfFilter}
          />
        </div>
      </div>
    </div>
  );
};
